var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[_c('v-layout',[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("This page no longer available!")]),_c('br')])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }